const styles = () => ({
  container: {
    background: '#f8f8f8',
    padding: '10px',
    borderRadius: '4px',
    marginBottom: '20px',
    border: '1px solid #e5e5e5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  separator: {
    width: '1px',
    height: '16px',
    margin: '0 20px',
    background: '#e5e5e5',
    display: 'block'
  },
  title: {
    marginRight: '20px'
  }
})

export default styles
